import * as XLSX from 'xlsx';

const HEADERS = [
  'Firma Adı',
  'Firma Aktif Mi',
  'Sektörler',
  'Ad Soyad',
  'Ünvan',
  'E-posta',
  'Telefon',
  'İkinci Telefon',
  'Kart Durumu',
];

const getFirmName = firm => firm?.firm_name || firm?.firm_short_name || '';

const getSectorsLabel = firm => {
  const list = Array.isArray(firm?.firm_sectors) ? firm.firm_sectors : [];
  const names = list
    .map(fs => fs?.sector?.sector_name)
    .filter(Boolean);
  return names.join(', ');
};

const getEstablishedLabel = firm => (firm?.is_established ? 'Evet' : 'Hayır');

const getFullName = cart =>
  [cart?.firm_cart_firstname, cart?.firm_cart_lastname]
    .filter(Boolean)
    .join(' ')
    .trim();

const buildRows = firms => {
  const rows = [];
  (firms || []).forEach(firm => {
    const baseRow = {
      firmName: getFirmName(firm),
      established: getEstablishedLabel(firm),
      sectors: getSectorsLabel(firm),
    };
    const carts = Array.isArray(firm?.firm_carts) ? firm.firm_carts : [];

    if (carts.length === 0) {
      rows.push([
        baseRow.firmName,
        baseRow.established,
        baseRow.sectors,
        '',
        '',
        '',
        '',
        '',
        '',
      ]);
      return;
    }

    carts.forEach(cart => {
      rows.push([
        baseRow.firmName,
        baseRow.established,
        baseRow.sectors,
        getFullName(cart),
        cart?.firm_cart_title || '',
        cart?.firm_cart_mail || '',
        cart?.firm_cart_phone || '',
        cart?.firm_cart_second_phone || '',
        cart?.firm_cart_status ? 'Aktif' : 'Pasif',
      ]);
    });
  });
  return rows;
};

const buildFilename = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `iletisim-raporu-${y}-${m}-${day}.xlsx`;
};

export function exportFirmCommunicationReport(firms = []) {
  const rows = buildRows(firms);
  const aoa = [HEADERS, ...rows];
  const worksheet = XLSX.utils.aoa_to_sheet(aoa);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'İletişim Raporu');
  XLSX.writeFile(workbook, buildFilename());
  return rows.length;
}

export default exportFirmCommunicationReport;
